import type { UniDriver } from '@wix/wix-ui-test-utils/unidriver';
import {
  baseUniDriverFactory,
  findByHookAtIndex,
} from '../test-utils/utils/unidriver';
import { dataHooks } from './constants';

const accordionDriverFactory = (base: UniDriver) => ({
  ...baseUniDriverFactory(base),

  // Gets the title by item index
  getItemTitleAt: (idx: number) =>
    findByHookAtIndex(base, dataHooks.item, idx)
      .$('[data-hook="title"]')
      .text(),

  // Gets the subtitle by item index
  getItemSubtitleAt: (idx: number) =>
    findByHookAtIndex(base, dataHooks.item, idx)
      .$('[data-hook="accordion-item-subtitle"]')
      .text(),

  // Checks whether an icon exist at item index
  /**
   * @deprecated
   * use 'isPrefixExistsAt' instead
   */
  isIconExistsAt: (idx: number) =>
    findByHookAtIndex(base, dataHooks.item, idx)
      .$('[data-hook="icon"]')
      .exists(),

  // Checks whether prefix exists at item index
  isPrefixExistsAt: (idx: number) =>
    findByHookAtIndex(base, dataHooks.item, idx)
      .$('[data-hook="icon"]')
      .exists(),

  // Checks whether suffix exists at item index
  isSuffixExistsAt: (idx: number) =>
    findByHookAtIndex(base, dataHooks.item, idx)
      .$('[data-hook="suffix"]')
      .exists(),

  // Checks whether an item is expanded at index
  isItemExpandedAt: (idx: number) =>
    findByHookAtIndex(base, dataHooks.item, idx)
      .$('[data-hook="children"]')
      .exists(),

  // Clicks toggle button at item index
  clickToggleButtonAt: (idx: number) =>
    findByHookAtIndex(base, dataHooks.item, idx)
      .$(`[data-hook="${dataHooks.toggleButton}"]`)
      .click(),

  // Clicks item at index
  clickItemAt: (idx: number) =>
    findByHookAtIndex(base, dataHooks.item, idx)
      .$('[data-hook="header"]')
      .click(),

  // Gets toggle button label at item index
  getToggleButtonLabelAt: (idx: number) =>
    findByHookAtIndex(base, dataHooks.item, idx)
      .$(`[data-hook="${dataHooks.toggleButton}"]`)
      .text(),

  // Gets transition speed
  getTransitionSpeed: () => base.attr('data-transition-speed'),

  // Returns skin
  getSkin: () => base.attr('data-skin'),

  // Returns size of horizontal padding
  getHorizontalPadding: () => base.attr('data-horizontal-padding'),
});

export default accordionDriverFactory;

export type AccordionUniDriver = ReturnType<typeof accordionDriverFactory>;
